import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  isMobile,
  PlatformMessagesWrapper,
  TableConnectionPopupsWr,
  TablePopUpContainer,
  useApplicationStore,
  usePopupStore,
} from '@pascal/pascal-core';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import { Web, Mobile } from '../../container';
import { SocketConnection } from '../../services/socketConnection';
import { ApplicationWrapper } from '../applicationWrapper';
import Popup from '../popup';
import { SoundWatcher } from '../soundWatcher';
import useTranslation from '../../hooks/useTranslation';
import { kenoGameService } from '../../services/gameService';
import { TranslationKeys } from '../../core/constants/translationKeys';

let timeOutId;
export const Factory = observer(() => {
  const t = useTranslation();
  const { gameIsOpen } = useApplicationStore();
  const { popupName, popupToggle } = usePopupStore();

  const popupMap = useMemo(
    () => ({
      [PopUps.Reconnect]: {
        component: TableConnectionPopupsWr,
        title: t(TranslationKeys.Reconnect),
      },
      [PopUps.ConnectionError]: {
        component: TableConnectionPopupsWr,
        title: t(TranslationKeys.ConnectionError),
      },
      [PopUps.GameOpen]: {
        component: TableConnectionPopupsWr,
        title: t(''),
      },
    }),
    [t]
  );

  useEffect(() => {
    if (popupName === PopUps.Reconnect || gameIsOpen) {
      kenoGameService.handleConnectionErrorAfterTimeOut();
    } else {
      clearTimeout(timeOutId);
    }
  }, [popupName, gameIsOpen]);

  const handleDocumentClick = useCallback(() => {
    kenoGameService.stopAnimation();
  }, []);

  useEffect(() => {
    document.addEventListener(isMobile() ? 'touchend' : 'click', handleDocumentClick, true);
    return () => {
      document.removeEventListener(isMobile() ? 'touchend' : 'click', handleDocumentClick, true);
    };
  }, [handleDocumentClick]);

  return (
    <>
      <PlatformMessagesWrapper>
        <SocketConnection />
      </PlatformMessagesWrapper>
      <ApplicationWrapper>
        {isMobile() ? <Mobile /> : <Web />}
        <Popup />
        <SoundWatcher />
        {(popupToggle || gameIsOpen) && (
          <TablePopUpContainer popupMap={popupMap} popUpName={popupName} gameIsOpen={gameIsOpen} />
        )}
      </ApplicationWrapper>
    </>
  );
});
